Groupon.qualtrics = function(e, h, f, g) {
  this.get = function(a) {
    var b, c, d, e1;
    a = a + '=';
    c = document.cookie.split(';');
    b = 0;
    e1 = c.length;
    while (b < e1) {
      d = c[b];
      while (' ' === d.charAt(0)) {
        d = d.substring(1, d.length);
      }
      if (0 === d.indexOf(a)) {
        return d.substring(a.length, d.length);
      }
      b++;
    }
    return null;
  };
  this.set = function(a, c) {
    var b;
    b = new Date;
    b.setTime(b.getTime() + 6048e5);
    b = '; expires=' + b.toGMTString();
    document.cookie = a + '=' + c + b + '; path=/; ';
  };
  this.check = function() {
    var a, c;
    a = this.get(f);
    if (a) {
      a = a.split(':');
    } else if (100 !== e) {
      'v' === h && (e = Math.random() >= e / 100 ? 0 : 100);
      a = [h, e, 0];
      this.set(f, a.join(':'));
    } else {
      return !0;
    }
    c = a[1];
    if (100 === c) {
      return !0;
    }
    switch (a[0]) {
      case 'v':
        return !1;
      case 'r':
        return c = a[2] % Math.floor(100 / c);
        a[2]++;
        this.set(f, a.join(':'));
        !c;
    }
    return !0;
  };
  this.go = function() {
    var a;
    if (this.check()) {
      a = document.createElement('script');
      a.type = 'text/javascript';
      a.src = g + '&t=' + (new Date).getTime();
      document.body && document.body.appendChild(a);
    }
  };
  this.start = function() {
    var a;
    a = this;
    if (window.addEventListener) {
      window.addEventListener('load', (function() {
        a.go();
      }), !1);
    } else {
      window.attachEvent && window.attachEvent('onload', (function() {
        a.go();
      }));
    }
  };
};

